import axios from 'axios';

// All portal requests share a finite timeout so a stalled API cannot keep a
// React Query observer (and its loading spinner) alive indefinitely.
const httpClient = axios.create({
  timeout: 15000,
});

export default httpClient;
